import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BellRinging01 = function BellRinging01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.3544 21c.7052.6224 1.6314 1 2.6458 1a3.985 3.985 0 0 0 2.6459-1M2.2941 5.8199C2.2798 4.3685 3.0623 3.0133 4.3264 2.3m17.376 3.5199c.0143-1.4513-.7682-2.8066-2.0322-3.5199m-1.67 5.7a6 6 0 1 0-12 0c0 3.0902-.7795 5.206-1.6503 6.6054-.7345 1.1805-1.1018 1.7707-1.0883 1.9354.0149.1823.0535.2518.2004.3608C3.5947 17 4.1928 17 5.3891 17h13.2223c1.1963 0 1.7944 0 1.9271-.0984.1469-.109.1855-.1785.2004-.3608.0135-.1647-.3538-.7549-1.0883-1.9354-.8708-1.3994-1.6504-3.5152-1.6504-6.6054"
    })
  }));
};
export default BellRinging01;